<template lang="pug">
filter-detail-container(:title="$t('filter_reply_status')" @back="back" @save="save" @clear="clear" :saveMode="false")
  template(v-slot:body)
    .pa-6
      .text-md.font-normal.mb-4 {{ $t('choose_reply_status_to_filter') }}
      div(v-for="status in replyStatuses" :key="status.value")
        .d-flex.align-center.text-sm.pa-6.cursor-pointer.hover-bg(@click="onSelect(status)")
          yc-checkbox.mr-4(v-model="selected" :value="status.value")
          .text-md.font-normal {{ status.text }}
        v-divider
</template>

<script>
import FilterDetailContainer from '@/components/connect/FilterDetailContainer.vue'

export default {
  name: 'FilterReplyStatus',
  components: {
    FilterDetailContainer,
  },
  props: {
    filter: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      replyStatuses: [
        {
          text: 'Not replied',
          value: false
        },
        {
          text: 'Replied',
          value: true
        }
      ],
      selected: []
    }
  },
  mounted() {
    if (this.filter.items) {
      this.selected = [...this.filter.items]
    }
  },
  methods: {
    onSelect(status) {
      if (this.selected.includes(status.value)) {
        this.selected = this.selected.filter(x => x !== status.value)
      } else {
        this.selected.push(status.value)
      }
    },
    save() {
      const filter = {}
      if (this.selected.length) {
        filter['items'] = this.selected
      }
      this.$emit('update:filter', filter)
      this.back()
    },
    back() {
      this.$emit('onBack')
    },
    clear() {
      this.selected = []
    }
  }
}
</script>

<style scoped>
</style>